import { ApprovalFlowGetData } from "../../CompanySettings/JobApproval/model/approvalsFlowModel";
import {
  ApplicationStatsResponse,
  Job,
  JobApplication,
  JobApplicationsResponse,
  JobDetails,
  JobSkill,
} from "../model/JobModel";
import { JobManagementAction } from "./job.action";

export interface JobPostingState {
  searchTerm: string;
  statusFilter: string;
  currentPage: number;
  // openMenu: boolean;
  viewMode: "list" | "grid";
  visibility: string;
  department: string;
  query: string;
  search: string;
  title: string;
  location: string;
  hiringManagerId: string;
  recruiterId: string;
  limit: number;
  offset: number;
  loading: boolean;
  error: string | null;
  jobs: Job[];
  total: number;
  activeJobs: number;
  totalApplications: number;
  hasMore: boolean;
  users: any[];
  applicationStats: ApplicationStatsResponse | null;
  jobDetails: JobDetails | null;
  selectedApplication: JobApplication | null;
  JobApplications: JobApplication[];
  applicationCurrentPage: number;
  applicationTotal: number;
  applicationLimit: number;
  applicationOffset: number;
  applicationsort_by: string;
  applicationInclude_profile: boolean;
  viewLoading: boolean;
  candidateViewLoading: boolean;
  ststusUpdateLoading: boolean;
  applivationView: boolean;
  contactPopupOpen: boolean;
  viewApplication: JobApplication | null;
  applicationQuery: any | null;
  toast: {
    isVisible: boolean;
    message: string;
    type: "success" | "error" | "warning" | "info";
  };
  openMenuJobId: string | null;
  deleteDialogOpen: boolean;
  deletingFlowId: string | null;
}

export type JobPostingAction =
  | { type: "SET_SEARCH_TERM"; payload: string }
  | { type: "SET_STATUS_FILTER"; payload: string }
  | { type: "SET_CURRENT_PAGE"; payload: number }
  | { type: "SET_APPLICATION_CURRENT_PAGE"; payload: number }
  | { type: "SET_OPEN_MENU"; payload: string | null }
  | { type: "SET_VIEW_MODE"; payload: "list" | "grid" }
  | { type: "SET_VISIBILITY"; payload: string }
  | { type: "SET_DEPARTMENT"; payload: string }
  | { type: "SET_SEARCH"; payload: string }
  | { type: "SET_TITLE"; payload: string }
  | { type: "SET_LOCATION"; payload: string }
  | { type: "SET_HIRING_MANAGER_ID"; payload: string }
  | { type: "SET_RECRUITER_ID"; payload: string }
  | { type: "SET_LIMIT"; payload: number }
  | { type: "SET_APPLICATION_LIMIT"; payload: number }
  | {
      type: "SET_CONTACT_POPUP";
      payload: {
        open: boolean;
        application: JobApplication | null;
      };
    }
  | { type: "SET_OFFSET"; payload: number }
  | { type: "SET_LOADING"; payload: boolean }
  | { type: "SET_ERROR"; payload: string | null }
  | { type: "SET_JOBS"; payload: any[] }
  | { type: "SET_TOTAL"; payload: number }
  | {
      type: "SET_JOB_SUMMARY";
      payload: {
        total?: number;
        active_jobs?: number;
        total_applications?: number;
        has_more?: boolean;
      };
    }
  | { type: "SET_APPLICATION_TOTAL"; payload: number }
  | { type: "OPEN_DELETE_DIALOG"; payload: string }
  | { type: "CLOSE_DELETE_DIALOG" }
  | { type: "OPEN_APPLICATION_VIEW"; payload: any }
  | { type: "SET_JOB_DETAILS"; payload: any }
  | { type: "SET_JOB_APPLICATIONS"; payload: JobApplication[] }
  | { type: "SET_VIEW_LOADING"; payload: boolean }
  | { type: "SET_CANDIDATE_VIEW_LOADING"; payload: boolean }
  | { type: "SET_STATUS_UPDATE_LOADING"; payload: boolean }
  | { type: "SET_VIEW_APPLICATIONS"; payload: JobApplication | null }
  | { type: "SET_APPLICATION_STATS"; payload: ApplicationStatsResponse }
  | { type: "SET_APPLICATION_QUERY"; payload: any }
  | {
      type: "SET_JOB_TOAST";
      payload: {
        isVisible: boolean;
        message: string;
        type: "success" | "error" | "warning" | "info";
      };
    }
  | { type: "HIDE_JOB_TOAST" }
  | { type: "SET_USERS"; payload: any[] };

export const initialState: JobPostingState = {
  searchTerm: "",
  statusFilter: "all",
  currentPage: 1,
  title: "",
  search: "",
  location: "",
  query: "",
  // openMenu: false,
  viewMode: "grid",
  visibility: "",
  department: "",
  jobDetails: null,
  hiringManagerId: "",
  recruiterId: "",
  limit: 8,
  offset: 0,
  loading: false,
  error: null,
  jobs: [],
  applicationStats: null,
  total: 0,
  activeJobs: 0,
  totalApplications: 0,
  hasMore: false,
  users: [],
  JobApplications: [],
  applicationQuery: null,
  applicationCurrentPage: 1,
  applicationTotal: 0,
  applicationLimit: 8,
  applicationOffset: 0,
  applicationsort_by: "applied_at",
  applicationInclude_profile: false,
  toast: {
    isVisible: false,
    message: "",
    type: "success",
  },
  selectedApplication: null,
  openMenuJobId: null,
  deleteDialogOpen: false,
  deletingFlowId: null,
  applivationView: false,
  viewLoading: false,
  candidateViewLoading: false,
  ststusUpdateLoading: false,
  contactPopupOpen: false,
  viewApplication: null,
};

export const jobPostingReducer = (
  state: JobPostingState,
  action: JobPostingAction,
): JobPostingState => {
  switch (action.type) {
    case "SET_SEARCH_TERM":
      return { ...state, searchTerm: action.payload };
    case "SET_STATUS_FILTER":
      return { ...state, statusFilter: action.payload };
    case "SET_CURRENT_PAGE":
      return { ...state, currentPage: action.payload };
    case "SET_APPLICATION_CURRENT_PAGE":
      return { ...state, applicationCurrentPage: action.payload };
    case "SET_OPEN_MENU":
      return { ...state, openMenuJobId: action.payload };
    case "SET_VIEW_MODE":
      return { ...state, viewMode: action.payload };
    case "SET_VISIBILITY":
      return { ...state, visibility: action.payload };
    case "SET_DEPARTMENT":
      return { ...state, department: action.payload };
    case "SET_SEARCH":
      return { ...state, search: action.payload };
    case "SET_TITLE":
      return { ...state, title: action.payload };
    case "SET_LOCATION":
      return { ...state, location: action.payload };
    case "SET_HIRING_MANAGER_ID":
      return { ...state, hiringManagerId: action.payload };
    case "SET_RECRUITER_ID":
      return { ...state, recruiterId: action.payload };
    case "SET_LIMIT":
      return { ...state, limit: action.payload };
    case "SET_APPLICATION_LIMIT":
      return { ...state, applicationLimit: action.payload };
    case "SET_OFFSET":
      return { ...state, offset: action.payload };
    case "SET_LOADING":
      return { ...state, loading: action.payload };
    case "SET_ERROR":
      return { ...state, error: action.payload };
    case "SET_JOBS":
      return { ...state, jobs: action.payload };
    case "SET_TOTAL":
      return { ...state, total: action.payload };
    case "SET_JOB_SUMMARY":
      return {
        ...state,
        total: action.payload.total ?? state.total,
        activeJobs: action.payload.active_jobs ?? state.activeJobs,
        totalApplications:
          action.payload.total_applications ?? state.totalApplications,
        hasMore: action.payload.has_more ?? state.hasMore,
      };
    case "SET_APPLICATION_TOTAL":
      return { ...state, applicationTotal: action.payload };
    case "SET_JOB_TOAST":
      return { ...state, toast: action.payload };
    case "HIDE_JOB_TOAST":
      return { ...state, toast: { ...state.toast, isVisible: false } };
    case "SET_APPLICATION_STATS":
      return {
        ...state,
        applicationStats: action.payload,
        applicationTotal: action.payload.total,
      };
    case "SET_CONTACT_POPUP":
      return {
        ...state,
        contactPopupOpen: action.payload.open,
        viewApplication: action.payload.application,
      };

    case "SET_APPLICATION_QUERY":
      return {
        ...state,
        applicationQuery: action.payload,
      };
    case "OPEN_APPLICATION_VIEW":
      return {
        ...state,
        applivationView: action.payload,
      };

    case "SET_JOB_APPLICATIONS":
      return {
        ...state,
        JobApplications: action.payload,
      };
    case "SET_VIEW_APPLICATIONS":
      return {
        ...state,
        selectedApplication: action.payload,
      };
    case "SET_VIEW_LOADING":
      return { ...state, viewLoading: action.payload };
    case "SET_CANDIDATE_VIEW_LOADING":
    case "SET_STATUS_UPDATE_LOADING":
      return { ...state, candidateViewLoading: action.payload };
    case "SET_STATUS_UPDATE_LOADING":
      return { ...state, ststusUpdateLoading: action.payload };
    case "SET_USERS":
      return { ...state, users: action.payload };
    case "SET_JOB_DETAILS":
      return {
        ...state,
        jobDetails: action.payload,
      };
    case "OPEN_DELETE_DIALOG":
      return {
        ...state,
        deleteDialogOpen: true,
        deletingFlowId: action.payload,
      };

    case "CLOSE_DELETE_DIALOG":
      return {
        ...state,
        deleteDialogOpen: false,
        deletingFlowId: null,
      };

    default:
      return state;
  }
};

interface ConfirmationState {
  isOpen: boolean;
  title: string;
  message: string;
  onConfirm: () => void;
  type: "danger" | "warning" | "info";
  loading: boolean;
}

export interface JobManagementState {
  formData: Partial<Job>;
  skills: JobSkill[];
  newSkill: JobSkill;
  showModal: boolean;
  toast: {
    isVisible: boolean;
    message: string;
    type: "success" | "error" | "warning" | "info";
  };
  jobs: Job[];
  error: string | null;
  validateErrors: JobFormErrors;
  editingJob: Job | null;
  isCreateFromDraft: boolean;
  searchTerm: string;
  activeTab: "jobs" | "applications" | "pendingApprovals";
  confirmation: ConfirmationState;
  users: any[];
  approvalFlows: ApprovalFlowGetData[];
  showApprovalPopup: boolean;
  selectedApprovalFlowId: string | null;
  submittingJobId: string | null;
}

export const jobManagementInitialState: JobManagementState = {
  formData: {
    title: "",
    department: "",
    location: "",
    hiring_manager_name: "",
    recruiter_name: "",
    job_type: undefined,
    remote: false,
    salary_min: "",
    salary_max: "",
    description: "",
    benefits: "",
    requirements: "",
    skills: [],
    job_function: "",
    salary_currency: undefined,
    salary_period: undefined,
    education_level: undefined,
    vacancies: 0,
    visa_sponsorship: null,
    relocation_offered: null,
    travel_percentage: 0,
    target_start_date: "",
    hiring_urgency: undefined,
    interview_process: "",
    external_url: "",
    application_email: "",
    application_deadline: "",
    max_applications: 0,
    posting_visibility: "",
    is_featured: false,
    approval_flow_id: "",
  },
  skills: [],
  newSkill: {
    skill_name: "",
    is_required: false,
    minimum_years: 0,
    proficiency_level: "beginner",
  },
  showModal: false,
  toast: {
    isVisible: false,
    message: "",
    type: "success",
  },
  jobs: [],
  validateErrors: {},
  error: null,
  editingJob: null,
  searchTerm: "",
  activeTab: "jobs",
  confirmation: {
    isOpen: false,
    title: "",
    message: "",
    onConfirm: () => {},
    type: "info",
    loading: false,
  },
  users: [],
  approvalFlows: [],
  showApprovalPopup: false,
  selectedApprovalFlowId: null,
  submittingJobId: null,
  isCreateFromDraft: false,
};

export const jobManagementReducer = (
  state: JobManagementState,
  action: JobManagementAction,
): JobManagementState => {
  switch (action.type) {
    case "SET_FORM_DATA":
      return { ...state, formData: { ...state.formData, ...action.payload } };
    case "UPDATE_FORM_FIELD":
      return {
        ...state,
        formData: {
          ...state.formData,
          [action.payload.field]: action.payload.value,
        },
      };
    case "ADD_SKILL":
      return { ...state, skills: [...state.skills, action.payload] };
    case "DELETE_SKILL":
      return {
        ...state,
        skills: state.skills.filter((s) => s.skill_id !== action.payload),
      };
    case "UPDATE_SKILL":
      return {
        ...state,
        skills: state.skills.map((skill) =>
          skill.skill_id === action.payload.skill_id
            ? { ...skill, ...action.payload.updates }
            : skill,
        ),
      };
    case "SET_NEW_SKILL":
      return { ...state, newSkill: action.payload };
    case "SET_SHOW_MODAL":
      return { ...state, showModal: action.payload };
    case "SET_TOAST":
      return { ...state, toast: action.payload };
    case "HIDE_TOAST":
      return { ...state, toast: { ...state.toast, isVisible: false } };
    case "SET_JOBS":
      return { ...state, jobs: action.payload };
    case "SET_ERROR":
      return { ...state, error: action.payload };
    case "SET_EDITING_JOB":
      return { ...state, editingJob: action.payload };
    case "SET_SEARCH_TERM":
      return { ...state, searchTerm: action.payload };
    case "SET_FORM_ERRORS":
      return { ...state, validateErrors: action.payload };
    case "CLEAR_FORM_ERROR":
      return { ...state, validateErrors: {} };
    case "SET_ACTIVE_TAB":
      return { ...state, activeTab: action.payload };
    case "SET_CONFIRMATION":
      return { ...state, confirmation: action.payload };
    case "HIDE_CONFIRMATION":
      return {
        ...state,
        confirmation: { ...state.confirmation, isOpen: false },
      };
    case "SET_USERS":
      return { ...state, users: action.payload };
    case "RESET_FORM":
      return {
        ...state,
        formData: jobManagementInitialState.formData,
        skills: [],
        newSkill: jobManagementInitialState.newSkill,
        validateErrors: {},
        editingJob: null,
        isCreateFromDraft: false,
      };
    case "PREFILL_FORM":
      return {
        ...state,
        formData: {
          ...state.formData,
          ...action.payload,
          hiring_manager_name: action.payload.hiring_manager_id,
          recruiter_name: action.payload.recruiter_id,
        },
        skills: action.payload.skills || [],
      };
    case "SHOW_APPROVAL_POPUP":
      return {
        ...state,
        showApprovalPopup: true,
        submittingJobId: action.payload.jobId,
        selectedApprovalFlowId: String(action.payload.flowId),
      };

    case "HIDE_APPROVAL_POPUP":
      return {
        ...state,
        showApprovalPopup: false,
      };
    case "SET_SELECTED_APPROVAL_FLOW":
      return {
        ...state,
        selectedApprovalFlowId: action.payload,
      };
    case "SET_CREATE_FROM_DRAFT":
      return { ...state, isCreateFromDraft: action.payload };
    case "SET_APPROVAL_FLOWS":
      return {
        ...state,
        approvalFlows: action.payload,
      };

    default:
      return state;
  }
};
export interface JobFormErrors {
  title?: string;
  department?: string;
  location?: string;
  job_type?: string;
  experience_level?: string;
  work_mode?: string;
  salary_min?: string;
  salary_max?: string;
  recruiter_name?: any;
  hiring_manager_name?: any;
  description?: string;
  posting_visibility?: string;
}
